export default __webpack_public_path__ + "static/Outlook-calender-hero-1-8aa602b9e457a4e0533518dcacd55dbe.webp";